import '../styles/header.scss';
// import LaunchdeckLogo from '../../../../
// styles/images/launchdeck_logo.svg';

import LaunchdeckLogo from '../../../../global/styles/images/launchdeck_logo.svg';
import { Box } from '@chakra-ui/react';
import HeaderLogo from './HeaderLogo';
import appConfig from '../../../../../config/app-config';


export default function GeneralHeader({logoToMainLandingPage}) {
	
	return (
		<nav className={`header header--default`}>
			<div className="header__container">
				{logoToMainLandingPage ?
					<Box ml='4em'>
						<a href={appConfig.landingPage} rel="noopener noreferrer">
							<img className="user-header__logo" draggable="false" src={LaunchdeckLogo} alt="Launchdeck Logo" />
						</a>
					</Box> :
					<HeaderLogo />
				}
			</div>
		</nav>
	);
}
